import React, { useState } from "react";
import { useOrder } from "../contexts/order";
import { OrderName, OrderStatus } from "../enums";
import classNames from "classnames";
import { FaEdit, FaTrash } from "react-icons/fa";
import DeleteOrderModal from "./modals/DeleteOrderModal";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import ShimmerTable from "./shimmer/ShimmerTable";
import { useAuth } from "../contexts/auth";

function getStatusColor(status) {
  switch (status) {
    case 0:
      return "bg-red-500";
    case 1:
      return "bg-yellow-300";
    case 2:
      return "bg-[#ffa500]";
    case 3:
      return "bg-blue-700";
    case 4:
      return "bg-green-600";
    case 5:
      return "bg-gray-300";
    default:
      return "bg-black";
  }
}

export default function OrderTable() {
  const [{ orders }] = useOrder();
  const [, { setFormState }] = useOrder();
  const [{ activeUser }] = useAuth();

  const [orderToDelete, setOrderTODelete] = useState();
  const navigate = useNavigate();
  function handeleRowClick(orderID) {
    navigate("/order-details/" + orderID);
  }

  if (!orders) {
    return (
      <div className="h-full">
        <ShimmerTable />
      </div>
    );
  }

  return (
    <div>
      <table className="dataTable">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Order NO</th>
            <th scope="col">Party Name</th>
            <th scope="col">size</th>
            <th scope="col">Label</th>
            <th scope="col">Core</th>
            <th scope="col">Ups</th>
            <th scope="col">Roll</th>
            <th scope="col">Paper Type</th>
            <th scope="col">Added By</th>
            <th scope="col">Order Date</th>
            <th scope="col">Due Date</th>
            <th scope="col">Type</th>
            {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
          </tr>
        </thead>

        <tbody>
          {orders &&
            orders.data.map((order) => {
              return (
                <tr
                  className={classNames(
                    "cursor-pointer",
                    order.order_status === 5 && "text-red-500"
                  )}
                  key={order.id}
                  onClick={() => handeleRowClick(order.id)}
                >
                  <td>
                    <span
                      className={classNames(
                        "block w-4 h-4 rounded-lg mx-auto",
                        getStatusColor(order.order_status)
                      )}
                      title={OrderStatus[order.order_status]}
                    ></span>
                  </td>
                  <td>{order.order_no ? order.order_no : order.id} </td>
                  <td>{order.party_name}</td>
                  <td>
                    {order.size}
                    {order.order_type === 1 && (
                      <span className="uppercase">
                        {" - "}
                        {order.daya_mtr} {order.mtr_daya}
                      </span>
                    )}
                  </td>
                  <td>{order.label}</td>
                  <td>
                    {order.core}{" "}
                    {order.cut && (
                      <span className="text-red-500">{`(${order.cut})`}</span>
                    )}
                  </td>
                  <td>{order.ups}</td>
                  <td>{order.roll - (order.ready_roll || 0)}</td>
                  <td>{order.paper_type}</td>
                  <td>{order.user?.name}</td>
                  <td>{format(new Date(order.created_at), "dd/MM/yyyy")}</td>
                  <td>{format(new Date(order.due_date), "dd/MM/yyyy")}</td>
                  <td>{OrderName[order.order_type]}</td>
                  {activeUser?.user_permission <= 2 && (
                    <td className="w-24">
                      {order.order_status !== 5 && (
                        <>
                          <button
                            className="bg-green-600 p-2 rounded-md my-1 text-white"
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormState({
                                type: order.order_type,
                                order: order,
                              });
                            }}
                          >
                            <FaEdit />
                          </button>
                          <button
                            className={classNames(
                              "p-2 rounded-md ml-2 bg-orange text-white"
                            )}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOrderTODelete({
                                id: order.id,
                                party_name: order.party_name,
                              });
                            }}
                          >
                            <FaTrash />
                          </button>
                        </>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
        </tbody>
      </table>
      <DeleteOrderModal {...{ orderToDelete, setOrderTODelete }} />
    </div>
  );
}
